import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { DocumentoAllegato } from '../../../../models/documento-allegato';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-mark-document-form',
  templateUrl: './mark-document-form.component.html',
  styleUrls: ['./mark-document-form.component.css']
})
export class MarkDocumentFormComponent implements OnInit {
  @Input() document: DocumentoAllegato;
  @Input() idFascicolo: string;
  @Output() onSubmit = new EventEmitter<any>();

  // FormGroup per gestire i controlli del form
  markForm: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.markForm = this.fb.group({
      posizioneTimbro: ['alto', Validators.required],
      tipoPagina: ['tutte', Validators.required],
      paginaSelezionata: [null, [Validators.min(1)]]
    });
    this.markForm.get('tipoPagina')?.valueChanges.subscribe((value) => {
      const paginaSelezionataControl = this.markForm.get('paginaSelezionata');
  
      if (value === 'tutte') {
        paginaSelezionataControl?.setValue(null); // Reset del numero pagina
        paginaSelezionataControl?.clearValidators();
      } else if (value === 'specifica') {
        paginaSelezionataControl?.setValidators([Validators.required, Validators.min(1)]);
      }
      
      paginaSelezionataControl?.updateValueAndValidity();
    });
    this.markForm.get('paginaSelezionata')?.valueChanges.subscribe(value => {
      if (value !== null && (value < 1 || value === 0)) {
        this.markForm.get('paginaSelezionata')?.setValue(1, { emitEvent: false });
      }
    });
  }

  applicaTimbro() {
    if (this.markForm.valid) {
      const { posizioneTimbro, tipoPagina, paginaSelezionata } = this.markForm.value;
      const payload = {
        idFascicolo: this.idFascicolo,
        idDocumento: this.document.id,
        posizione: posizioneTimbro,
        pagine: tipoPagina === 'tutte' ? 'tutte' : paginaSelezionata
      };

      console.log('Dati timbratura:', payload);
      this.onSubmit.emit(payload);
    }
  }
}
